import React from 'react';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

const Breadcrumbs = ({ items, className = '' }) => {
  const navigate = useNavigate();
  
  const handleClick = (to) => {
    if (to) {
      navigate(to);
    }
  };

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <nav className={`flex items-center text-sm truncate ${className}`}>
      {items.map((item, idx) => (
        <React.Fragment key={idx}>
          {idx > 0 && <ChevronRightIcon className="h-3 w-3 mx-1.5 text-gray-600 flex-shrink-0" />}
          {item.to ? (
            <button 
              onClick={() => handleClick(item.to)} 
              className="text-gray-400 hover:text-gray-300 transition-colors whitespace-nowrap"
            >
              {item.label}
            </button>
          ) : (
            <span className="text-gray-200 font-medium truncate whitespace-nowrap">
              {item.label}
            </span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumbs; 